var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card", staticStyle: { width: "100%" } }, [
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", {
            staticClass: "h1 font-large-1 d-inline-block",
            domProps: { textContent: _vm._s(_vm.job.title) },
          }),
          _vm._v(" "),
          _vm.data.organisation_logo !== null
            ? _c("div", { staticClass: "float-right pl-05" }, [
                _c("img", {
                  attrs: { src: _vm.data.organisation_logo.url, width: "150" },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("div", {}, [
              _c(
                "p",
                { staticClass: "primary text-bold-700 font-medium-3 mb-05" },
                [
                  _c("i", { staticClass: "fa fa-briefcase" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.employment_type) +
                      "\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: " font-small-3 text-light" }, [
                _c("i", { staticClass: "fa fa-map-marker" }),
                _vm._v(" " + _vm._s(_vm.data.position_location)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pt-1 pb-1 border-bottom breakAll" }, [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: { innerHTML: _vm._s(_vm.data.position_description) },
              }),
            ]),
            _vm._v(" "),
            _vm.data.disabled === 1
              ? _c("div", { staticClass: "p-1" }, [
                  _c("div", { staticClass: "card bg-outline-gray" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h4", { staticClass: "card-title danger" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("globals.disabled_job_box_header"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _vm._v(
                        _vm._s(_vm.__("globals.disabled_job_box_content"))
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.hide_salary == 0
              ? _c("div", { staticClass: "pt-1 pb-1 border-bottom" }, [
                  _c("strong", [_vm._v(" Salary:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.custom_salary) +
                      "\n                    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center pt-1 pb-1" }, [
              _c("div", [
                _c("div", { staticClass: "pb-1" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.__("job.company_name")) + ":"),
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.data.organisation_name) +
                      "\n                            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.__("job.company_description")) + ":"),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "breakAll",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.organisation_description),
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.data.hide_organisation_size == 0
                  ? _c("div", { staticClass: "pt-1" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.__("job.company_size")) + ":"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.organisation_size) +
                          "\n                            "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.user.confirmed === "1"
              ? _c("div", { staticClass: "d-flex mt-1" }, [
                  !_vm.data.isPositionClosed
                    ? _c("div", [
                        _vm.data.external_link === null
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-sm btn-primary waves-effect waves-light ",
                                  attrs: {
                                    href:
                                      "/member/job-applies?apply=" +
                                      _vm.data.slug,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.__(
                                        "job.form.links.apply_for_position"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm.data.external_link !== null
                          ? _c("span", { staticClass: "ml-auto" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-sm btn-primary waves-effect waves-light ",
                                  attrs: {
                                    href: _vm.data.external_link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.__("job.form.buttons.view_job_site")
                                    ) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "feather icon-chevron-right",
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _c(
                        "div",
                        { staticClass: "btn-outline-danger p-05 rounded" },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.__("job.form.paragraph.application_closed")
                              )
                            ),
                          ]),
                        ]
                      ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.data.isPositionClosed
              ? _c("div", { staticClass: "pt-1" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.__("job.application_close")) + ":"),
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.close_date) +
                      " @\n                        " +
                      _vm._s(_vm.data.close_time) +
                      "\n\n                    "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex border-top justify-content-between" },
          [
            _c(
              "div",
              { staticClass: "font-small-3 text-bold-700" },
              [
                _c("likes", {
                  attrs: {
                    id: _vm.data.slug,
                    "likes-count": _vm.data.likesCount,
                    "is-liked": _vm.data.isLiked,
                    "liked-by-users": _vm.data.userLikes,
                    type: "job",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-3 text-bold-700" }, [
              _c(
                "a",
                {
                  staticClass: "d-block p-05",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.commentsShow = !_vm.commentsShow
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-comment-o" }),
                  _vm._v(" "),
                  _vm.commentsCount === 1
                    ? _c("span", [
                        _c("span", {
                          domProps: { textContent: _vm._s(_vm.commentsCount) },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                      ])
                    : _c("span", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.commentsCount === 0 ? " " : _vm.commentsCount
                            ),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                      ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "font-small-3 text-bold-700" },
              [
                _c("social-share", {
                  attrs: { id: _vm.data.id, social: _vm.data.socialShare },
                  on: { shareModal: _vm.triggerShareModal },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.commentsShow
      ? _c(
          "div",
          [
            _c("comments", {
              attrs: {
                newsfeed_uuid: _vm.data.newsfeed_uuid,
                id: _vm.data.slug,
                type: "job",
              },
              on: { length: _vm.updateCommentsCount },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.share_newsfeed
      ? _c(
          "div",
          [
            _c("share-modal", {
              attrs: {
                original_newsfeed_id: _vm.data.newsfeed_id,
                module: _vm.data,
                type: "job",
              },
              on: {
                closeModal: function ($event) {
                  _vm.share_newsfeed = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }